import { Component, EventEmitter } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import * as moment from 'moment';

import { LoadingController } from 'ionic-angular';
import { IonicSelectableComponent } from 'ionic-selectable';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { UploadingProvider } from '../../providers/uploading/uploading';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';
import { EventEmitterProvider } from '../../providers/event-emitter/event-emitter';
import { ProofServerProvider } from "../../providers/proof-server/proof-server";

import { RegistrationDocument } from '../../models/registrationdocument';
import { FileUploader, FileLikeObject } from  'ng2-file-upload';

import { NgZone } from '@angular/core';
import * as Config from "../../app/app.config";
import {Certificationdocument} from "../../models/certificationdocument";

/**
 * Generated class for the UpdateRegistrationDocumentPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-update-certification-document',
  templateUrl: 'update-certification-document.html',
})
export class UpdateCertificationDocumentPage {

  public fileUploader: FileUploader = new FileUploader({queueLimit : 1});
  public hasBaseDropZoneOver: boolean = false;

  private user: any;
  private proof: any;
  private hasApprovedCertification: boolean;
  public registrationDocument: RegistrationDocument;
  public certificationDocument: Certificationdocument;
  public userFilesGet: any[] = [];
  public mandatoryDocumentation = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider,
    private uploadingprovider: UploadingProvider,
    private zone: NgZone,
    private proofServerProvider: ProofServerProvider
  ) {
    this.hasApprovedCertification = false;

    this.certificationDocument = new Certificationdocument();

    this.user = this.authProvider.getUser();

    if (this.user) {

    }
  }

  fileOverBase(event): void {
    this.hasBaseDropZoneOver = event;
  }

  getFiles(): FileLikeObject[] {
    return this.fileUploader.queue.map((fileItem) => {
      console.log('getFiles', fileItem.file);
      return fileItem.file;

    });
  }

  ionViewDidLoad() {
    this.checkFiles();
    console.log('ionViewDidLoad UpdateRegistrationDocumentPage');
  }

  checkFiles(){
    let loader = this.loadingCtrl.create({
      content: 'Obtendo Arquivos...',
      // duration: 3000
    });
    loader.present();
    this.uploadingprovider.listCertificationsFiles(this.user.id).subscribe((response: any) => {
      if (response) {
        this.userFilesGet = response;

        this.userFilesGet.forEach((file) => {
          if (file.validated === '1' || file.validated === null) {
            this.hasApprovedCertification = true;
          }
        });

        console.log('listCertificationsFiles response ->' , this.userFilesGet);
        loader.dismiss();
      }
    }, (error: any) => {
      console.log(error);
      loader.dismiss();
      this.alertProvider.doAlert('Houve problemas ao tentar verificar se existem arquivos em anexo.', 'Atenção');
    });
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  onDocumentKindChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('document kind:', event.value);
  }

  onScholarityChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('scholarity:', event.value);
  }


  doSave() {
    let countFiles = 0;
    this.fileUploader.queue.map((fileItem) => {
      countFiles++;
    });

    console.log('sei la');
    console.log(this.certificationDocument.validaty);

    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar o documento.', 'Atenção');
    } else if (countFiles === 0) {
      this.alertProvider.doAlert('É necessário adicionar um arquivo para upload.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.certificationDocument.validaty)) {
      this.alertProvider.doAlert('Forneça a data de validade do documento.', 'Atenção');
    } else {

      let momentCurrent = moment();
      let momentValidity = moment(this.certificationDocument.validaty, 'DD/MM/YYYY');

      if(!momentValidity.isValid()) {
        this.alertProvider.doAlert('Forneça uma data válida para o certificado.', 'Atenção');
      }
      else if (momentCurrent.isAfter(momentValidity)) {
        this.alertProvider.doAlert('A data de validade do certificado precisa ser maior que a data atual.', 'Atenção');
      }
      else {

        let that = this;
        this.alertProvider.doConfirm('Deseja salvar seu documento?', () => {
          let loader = that.loadingCtrl.create({
            content: 'Enviando pedido...',
            // duration: 3000
          });
          loader.present();

          let files = this.getFiles();

          files.forEach((file) => {
            let formData = new FormData();
            let userId = this.user.id;
            formData.append('file', file.rawFile);
            /*formData.append('proofId', Config.proofId.toString());*/
            formData.append('validaty', moment(this.certificationDocument.validaty, 'DD/MM/YYYY').format('YYYY-MM-DD'));
            this.uploadingprovider.uploadFormCertificationData(formData, userId).subscribe((response: any) => {
              if ((response) && (response.updated)) {
                loader.dismiss();
                this.checkFiles();
                console.log("updateCertificationDocument", response);
              }
            });
          });

        });
      }
    }
  }

  removeFile(fileId){
    this.uploadingprovider.removeCertificationFile(fileId).subscribe((response: any) => {
      if ((response) && (response.updated)) {
        //loader.dismiss();
        this.checkFiles();
        console.log("removeCertificationFile", response);
      }
    });
  }

  reprovedDescription(msg) {
    this.alertProvider.doAlert(msg, 'Motivo de Reprovação');
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-certification-document/update-certification-document.ts